export default __webpack_public_path__ + "static/media/4crackers.23b000b3.svg";